import React from "react";
import { connect } from 'react-redux'
import ReactTimeout from 'react-timeout';
import {Redirect} from 'react-router-dom';

import NewAndEdit from './NewAndEdit/'
import ParentComponent from './ParentComponent'

import { whereBallsMove, getHeader, isSimilarObject } from "../../helper"
import { getOrderById, clearExecutor} from '../../actions/orderActions';
import { fetchInfo } from '../../actions/';

class MakeOrder extends React.Component {
    state = {
        loading: true,
        requestForBidding: false,
    }

    componentWillMount() {
        const {dispatch, match } = this.props;
        let id_order = match.params.id;

        if (id_order) {
            dispatch(
                getOrderById(
                    {id: id_order},
                    getHeader(),
                    false,
                    (data) => {
                        document.title = data.title;
                        this.setState({loading: false})
                    }
                )
            );

            dispatch(fetchInfo([
                {
                    query: 'settings',
                    params: {},
                }
            ]));
        }else{
            this.setState({
                loading: false
            })
        }
    }

    componentDidMount() {
        document.title = 'Fixfact';
        whereBallsMove(4)
    }

    componentWillReceiveProps (nextProps) {
        const { dispatch, match } = this.props;
        const { params:{id} } = match;
        const nextParams = nextProps.match.params;

        if(id !== nextParams.id && nextParams.id){
            dispatch(getOrderById(
                {id: nextParams.id},
                getHeader(),
                true
            ));
        }

        // if(!isSimilarObject(match.params !== nextParams)){
        //     console.warn()
        // }
    }

    componentWillUnmount() {
        this.props.dispatch(clearExecutor());
        clearInterval(this.intervalFn);
    }

    getBinddingDataWithInterval() {
        const { dispatch, orderList:{orderById} } = this.props;
        let id_order = orderById.data.id;

        if(this.state.requestForBidding) return false;

        this.setState({
            requestForBidding:true
        }, () => {
            this.intervalFn = setInterval(() => {
                dispatch(getOrderById({id: id_order }, getHeader(), true));
                clearInterval(this.intervalFn)
                this.setState({requestForBidding:false})
            }, 60000);
        });
    }

    getMakeOrderComponent() {
        
        const {orderList:{orderById}, match, history, session} = this.props;
        let orderId = (match.params.id && orderById.data.id) ? orderById.data.id : null;

        if(
            match.params.id && !orderById.data.id &&
            !orderById.isFetching && !orderById.updating
        ) {
            return <Redirect to='/404'/>
        }

        if(!orderId && !session.isLoggedIn) {
            return <Redirect to='/404'/>
        }
        
        if (orderId) {
            const { status, is_failed } = orderById.data;
            const currentOrder = orderById.data;
            
            if((!status || status === 6 || is_failed === true) && this.state.requestForBidding){
                this.setState({
                    requestForBidding: false
                }, () => clearInterval(this.intervalFn));
            }

            if(((status && status > 0 && status !== 6) && !is_failed) && !this.state.requestForBidding){
                this.getBinddingDataWithInterval();
            }

            switch (status) {
                case 0:
                    return <NewAndEdit params={match.params} history={history}/>
                case 1: 
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                return <ParentComponent params={match.params} currentOrder={currentOrder} history={history}/>
                default:
                    return ('');
            }
        } else {
            return <NewAndEdit history={history} params={match.params} />
        }

    }

    render() {
        const {loading} = this.state;
        const { isFetching, updating } = this.props.orderList.orderById;

        if((loading || isFetching) && !updating) return <div></div>
        
        return (
            <div>
                {
                    this.getMakeOrderComponent()
                }
            </div>
        )   
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default ReactTimeout(connect(mapStateToProps)(MakeOrder));


// WEBPACK FOOTER //
// ./src/components/MakeOrder/index.js